module.exports = __webpack_public_path__ + "static/media/about1.2ed5f01a.jpg";